import { driftEmptyStateBuilder } from 'components/States'
import { FilterPage } from 'utils/filters'

import { useAppSelector } from './useRedux'

const emptyComponentNotFiltered = driftEmptyStateBuilder(
  'No account activity yet',
  'Once your accounts visit your site, it will show up here.'
)
const emptyComponentFiltered = driftEmptyStateBuilder(
  'We couldn’t find any activities matching your filters.',
  [
    'Try removing or editing some filters to see activities here. ',
    'Using Salesforce attribute filters? Updates to things like ',
    'account ownership can take 24 hours to be reflected in Drift.'
  ].join('')
)
const emptyComponentSearch = driftEmptyStateBuilder(
  'We couldn’t find any activities matching your search.',
  'Try refining your search terms to see activity here.'
)

export const useEmptyComponent = () => {
  const { searchQuery, filterGroupsByPage } = useAppSelector(({ filters }) => filters)
  const filterGroups = filterGroupsByPage[FilterPage.ACTIVITIES]
  const filters = filterGroups.reduce((flattened, group) => [...flattened, ...group], [])

  return !searchQuery || searchQuery?.length === 0
    ? filters.length > 0
      ? emptyComponentFiltered
      : emptyComponentNotFiltered
    : emptyComponentSearch
}
